// eslint-disable-next-line import/prefer-default-export
export function getSortDirection(columnName, order) {
  if (columnName === order.column) {
    if (order.isAscending) return 'asc';
    return 'desc';
  }
  return false;
}
